import { Tooltip } from "@/components/ui/tooltip";
import { PersonaDetalle } from "@/pages/persons/schema/person.schema";
import { AppColors } from "@/styles/colors";
import { Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: PersonaDetalle;
  handlePersonDetail: (id: any) => void;
}

export const PersonActions = ({ handlePersonDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Eye
        cursor="pointer"
        onClick={() => handlePersonDetail(item?.id)}
        data-testid={`eye-icon-${item?.id}`}
      />
    </Tooltip>
  );
};
